import type { ImpactArea } from './impact-of-disability_types'

// A disability with a single impact area hides the picker and composes from that area.
export function composedImpactAreas(selected: ImpactArea[], options: ImpactArea[]): ImpactArea[] {
  if (selected.length > 0) return selected
  return options.length === 1 ? options : []
}
